/**
 * 成本看板自己的规则。数字怎么显示不在这里 —— 那是 `llm-format.js` 的事。
 */

/**
 * 比率要染色的最小样本量。21 次调用里 3 次失败就把卡片刷红,是噪声不是信号 ——
 * 调用数和失败数都得够这个量,颜色才代表「真的在坏」。
 */
const MIN_TONE_SAMPLE = 20

/**
 * 失败率卡片染不染色。样本不够就是 neutral —— 小样本上的比率跳得比信号还快。
 * @param {number} calls
 * @param {number} failedCalls
 * @returns {'neutral'|'danger'}
 */
export function failureToneOf(calls, failedCalls) {
  if (calls < MIN_TONE_SAMPLE || failedCalls < MIN_TONE_SAMPLE) return 'neutral'
  return 'danger'
}

/**
 * 一个模型在图上和表里的名字。能力必须带上：不同能力的输入、输出和计量方式不同。
 * @param {{ capability: string, provider_display_name: string, provider_capability_code: string, model: string }} slice
 */
export function modelLabelOf(slice) {
  return `${slice.capability} / ${slice.provider_display_name} · ${slice.provider_capability_code} / ${slice.model}`
}
